import {
    Swiper,
    Navigation,
    Pagination,
    Autoplay,
    Thumbs
} from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let arenaSlider = new Swiper(".arena__slider", {
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 32,
        navigation: {
            nextEl: ".arena-button-next",
            prevEl: ".arena-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
        },
    }); 

    const slideCourts = new Swiper(".slider-courts", {
        spaceBetween: 30,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            900: {
                slidesPerView: 5,
                spaceBetween: 12,
            },
        },
    });

    const slideCourts2 = new Swiper(".slider-courts2", {
        spaceBetween: 1,
        navigation: {
            nextEl: ".courts-button-next",
            prevEl: ".courts-button-prev",
        },
        thumbs: {
            swiper: slideCourts,
        },
    });

    slideCourts.on("slideChange", () => {
        const iframes = document.querySelectorAll(".slider-courts iframe");
        iframes.forEach(iframe => {
            const src = iframe.src;
            iframe.src = src;
        });
    });

    console.log("Swiper inicializado com a configuração padrão (vertical).");

    let countSeconds = 0;
    const maxTime = 30;

    const intervaloDeVerificacao = setInterval(() => {
        const courtsContainer = document.querySelector(".courts__items");
        
        const horizontalMode = courtsContainer && courtsContainer.classList.contains("horizontal-videos");

        if (horizontalMode) {
            if (window.matchMedia("(min-width: 900px)").matches) {
                console.log("Desktop detectado: aplicando layout horizontal...");
    
                slideCourts.params.slidesPerView = 3;
                slideCourts.params.breakpoints[900].slidesPerView = 3;
    
                slideCourts.update();
            } else {
                console.log("Mobile detectado: ignorando alteração de layout.");
            }

            clearInterval(intervaloDeVerificacao); 
            return;
        }

        countSeconds++;

        if (countSeconds >= maxTime) {
            console.log("Verificação encerrada após 30 segundos. O layout não foi alterado.");
            clearInterval(intervaloDeVerificacao);
        }
    }, 1000);

    let mobileSliderHome = new Swiper(".mobile__slider-home", {
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1500,
        autoplay: {
            delay: 1500,
            disableOnInteraction: false,
        },
    });
};
